import { useState, useEffect, useMemo } from 'react';
import { ethers } from 'ethers';
import SwapTokens from './Swap';
import abi from '../abi.json';

function IndexFundBalance({ address }) {
  const [balance, setBalance] = useState(0);
  
  useEffect(() => {
    async function fetchBalance() {
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();
      const contract = new ethers.Contract('0x0778c3c02aBd153F10BAdC0EDa5166c352cB7D60', abi, signer); // <-- Move this line here
      
      const balance = await contract.getIndexBalance(address);
      setBalance(balance.toString());
    }
    fetchBalance();
  }, [address]); // <-- Update the dependencies
  
  // Or you can wrap the contract initialization in agetIndexBalance useMemo hook
  // const contract = useMemo(() => new ethers.Contract('0x123...', abi, signer), [signer]);

  return(<div>
  
        {balance}
        <SwapTokens/>
        
    </div>)
}


export default IndexFundBalance;
